import "react-phone-input-2/lib/style.css"
import PhoneInput from "react-phone-input-2"
import { Box, HStack, Stack } from "@chakra-ui/react"
import { Input, Text } from "./"

interface TextFieldProps {
  label: string
  placeholder?: string
  value: string
  type?: string
  required?: boolean
  onChange: (v: string) => void
}

export const TextField = ({ label, placeholder, type, value, required, onChange }: TextFieldProps) => {
  const formatSSN = (input: string) => {
    // Remove all non-digits
    const digits = input.replace(/\D/g, "")
    // Apply formatting
    const part1 = digits.slice(0, 3)
    const part2 = digits.slice(3, 5)
    const part3 = digits.slice(5, 9)

    let formatted = part1
    if (part2) formatted += `-${part2}`
    if (part3) formatted += `-${part3}`

    return formatted
  }
 
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputVal = e.target.value
    if (type === "ssn") {
      onChange(formatSSN(inputVal))
    } else {
      onChange(inputVal)
    }
  }

  return (
    <Stack w="100%">
      <HStack gap={1}>
        <Text fontSize="sm" fontWeight="bold">{label}</Text>
        {required && (
          <Box
            w="6px"
            h="6px"
            bg="red.500"
            borderRadius="full"
            mt="2px"
          />
        )}
      </HStack>
      {
        type === "phone" ? (
          <PhoneInput
            country={"us"}
            value={value}
            onChange={(value) => onChange(value)}
            inputProps={{
              name: "phone",
              required: true,
            }}
            inputStyle={{
              fontFamily: "Nunito Sans"
            }}
          />
        ) : (
          <Input placeholder={placeholder} type={type} value={value} onChange={handleChange} required={required} />
        )
      }
    </Stack>
  )
}